
import { createI18n } from 'vue-i18n'

import { localRead } from '@/libs/util'
import customZh from './lang/zh-CN'

import zh from 'view-ui-plus/dist/locale/zh-CN'


// 自动根据浏览器系统语言设置语言
// const navLang = navigator.language
// const localLang = (navLang === 'zh-CN' || navLang === 'en-US') ? navLang : false
let lang = 'zh-CN'   // localRead('local') || localLang ||  'zh-CN'



const messages = {
  'zh-CN': Object.assign(zh, customZh)
}

const i18n = createI18n({
  allowComposition: true,
  globalInjection: true,
  legacy: false,
  locale: lang,
  messages
});


export default i18n

// vue-i18n 5.x写法
// Vue.locale('zh-CN', Object.assign(zhCnLocale, customZhCn))
// Vue.locale('en-US', Object.assign(zhTwLocale, customZhTw))
// Vue.locale('zh-TW', Object.assign(enUsLocale, customEnUs))
